import React from "react";
import DashboardLayout from "../../layout/dashboardLayout";
import { BetSlipProvider } from "../../../context/BetSlipProvider";
import BetBuilderPanel from "../../betBuilder/BetBuilderPanel";
import Openbettable from "./openbettable";
import "../staightPage/staightPage.css";
import "./openbetPage.css";

const Openbet = () => {
  return (
    <DashboardLayout>
      <BetSlipProvider stayOnPageAfterSubmit>
        <section className="staightPage">
          <div
            style={{ height: "100%", overflowY: "auto" }}
            className="pageContentPart"
          >
            <Openbettable />
          </div>
          <BetBuilderPanel />
        </section>
      </BetSlipProvider>
    </DashboardLayout>
  );
};

export default Openbet;
